import React, { Component, Fragment } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import hall1D from '../../asset/image/hall1.jpg';

export class CourseDetails extends Component {
  render() {
    return (
      <Fragment>
        <Container className='mt-5'>
            <Row>
                <Col lg={8} md={6} sm={12}>
                <h1 className='CourseDetailText'>Course Details</h1>
                <hr />
                <img className='CourseDetailImage' src={hall1D} alt="" />

                <p> jhfhfvjghvhvhkv jbhjvh hvhvhyv  khyvhyyvhkvhkv</p>
                </Col>
              
              <Col lg={4} md={6} sm={12}>
              <div className='courseFeature'>
                <h1 className='text-center'> Events Feature</h1>
                <hr />
                <ul>
                  <li> <span> Enrolled : </span> 1200 Students</li>
                  <li> <span> Duration : </span> 8 hourse</li>
                  <li> <span> Parking Facalities : </span> Yes Its free</li>
                 
                </ul>


              </div>
                
                </Col>

            </Row>
        </Container>
      </Fragment>
    )
  }
}

export default CourseDetails
